/*@ngInject*/
export default ['$resource', 'BASE_URL', function($resource, BASE_URL) {
  return $resource(BASE_URL + '/msisdns/:resource/:id', {}, {
    available: { method: 'GET', isArray: true, params: { resource: 'available' } },
    clientAvailable: { method: 'GET', isArray: true, params: { resource: 'client' } },
    customersMsisdns: { method: 'GET', isArray: true },
    isEea: { method: 'GET', params: { resource: 'is-eea' } },
    buyNumber: { method: 'POST', params: { resource: 'assign' } },
    limitsExceeded: { method: 'GET', params: { resource: 'limits-exceeded' } },
    assignInitialNumber: { method: 'POST', params: { resource: 'assign-initial' }, ignoreInterceptor: true },
    getPricing: { method: 'GET', params: { resource: 'pricing', id: '@id' } },
    existsLabel: { method: 'GET', params: { resource: 'exists' }, ignoreLoadingBar: true },
    updateLabel: { method: 'PUT', params: { id: '@id' } }
  });
}];
